import script from "./AdminForgotPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminForgotPassword.vue?vue&type=script&setup=true&lang=js"

import "./AdminForgotPassword.vue?vue&type=style&index=0&id=6c74cd9b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c74cd9b"]])

export default __exports__